import { CloseConsumerDataPullSessionAction } from '../../actions/consumerDataPullSessionActions/closeConsumerDataPullSessionActions'
import {
	CONSUMER_SESSION_ACTIONS,
	ConsumerSessionDataAction,
} from '../../actions/consumerDataPullSessionActions/consumerSessionDataActions'
import { BankError } from '#modules/Bank/Bank.types'

const INITIAL_STATE = {
	closingConsumerDataPullSession: false,
	closeConsumerDataPullSessionError: null as BankError | null,
	closed: false,
}

export type CloseConsumerDataPullSessionState = typeof INITIAL_STATE

export default function clientReducer(
	state: CloseConsumerDataPullSessionState = INITIAL_STATE,
	action: CloseConsumerDataPullSessionAction | ConsumerSessionDataAction,
): CloseConsumerDataPullSessionState {
	switch (action.type) {
		case 'transactionClientApp/consumerPullSessions/close':
			return {
				...state,
				closingConsumerDataPullSession: true,
			}
		case 'transactionClientApp/consumerPullSessions/closeSucceeded':
			return {
				...state,
				closingConsumerDataPullSession: false,
				closed: true,
			}
		case 'transactionClientApp/consumerPullSessions/closeFailed':
			return {
				...state,
				closingConsumerDataPullSession: false,
				closeConsumerDataPullSessionError: action.payload,
			}

		case CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_SUCCEEDED:
			return {
				...state,
				closed: false,
				closeConsumerDataPullSessionError: null,
				closingConsumerDataPullSession: false,
			}
		default:
			return state
	}
}
